import { useSelectedLocation } from '@/hooks/useSelectedLocation';

// Thin adapter over the shared useSelectedLocation store for all Game Plan
// surfaces (Roadmap / This Week / Goal Board / Owner Playbook). This page's
// prior standalone storage key is one-time migrated into the shared store's
// key by useSelectedLocation's readStoredLocationId (see LEGACY_LOCATION_KEYS
// in useSelectedLocation.ts).
export function useGamePlanLocation() {
  const { locationId, setLocationId, locations } = useSelectedLocation({
    allowAll: false,
  });

  const currentLocation = locations.find((l) => l.id === locationId);
  return {
    locations,
    locationId: locationId || undefined,
    setLocationId,
    currentLocation,
  };
}
